const ww = $(window).width()
if (ww < 1200) {
  const heroHeader = heroHeader || {}
  heroHeader.VIEW_HEIGHT = {
    init: function() {
      this.setParameters()
      this.setMvHeight()
      this.bind()
    },
    setParameters: function() {
      this.$window = $(window)
      this.$target = $('#js-main-visual')
    },
    bind: function() {
      var _self = this
      this.$window.on('resize', function() {
        _self.setMvHeight()
      })
    },
    setMvHeight: function() {
      this.$target.css('height', this.$window.height())
    }
  }

  heroHeader.VIEW_HEIGHT.init()
}
